import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateUtils {
  formatIsoToDateTime(isoString: unknown): string {
    if (typeof isoString !== 'string') return '';

    const utcString = isoString.endsWith('Z') ? isoString : `${isoString}Z`;
    const date = new Date(utcString);
    if (isNaN(date.getTime())) return '';

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return new Intl.DateTimeFormat(navigator.language || 'pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short',
      timeZone: userTimeZone,
      hour12: false,
    })
      .format(date)
      .replace(',', ' -');
  }

  formatIsoToDateOnly(isoString: string): string {
    const date = new Date(isoString);

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  }
}
